export enum PerfilEnum {
  Superadmin = 1,
  Admin,
  Atendente,
  Parceiro,
  Solicitante
}
